"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _gdgl;
var _default = exports.default = {
  all: {
    day: "D",
    month: "M",
    year: "Y",
    hour: "H",
    week: "WEEK",
    monday: "Mon.",
    tuesday: "Tue.",
    wednesday: "Wed.",
    thursday: "Thu.",
    friday: "Fri.",
    saturday: "Sat.",
    sunday: "Sun.",
    startTime: "Start Time",
    endTime: "End Time",
    ksxz: "Fast Select",
    sjjg: "Time Interval",
    ys: "original",
    wfz: "Five Minutes",
    yxs: "One Hour",
    zjst: "3days",
    zjyz: "1weeks",
    zjyy: "1months",
    zjsy: "3months",
    zjly: "6months",
    zjyn: "1years",
    zjsn: "3years",
    cx: "Query",
    dc: "Export",
    sjxz: "Data Selection",
    qx: "Cancel",
    bc: "Save",
    timexz: "Time Selection",
    quanxuan: "Check All",
    fx: "Inverse",
    xz: "Download",
    yl: "Preview",
    pldc: "Batch Export",
    sc: "Upload",
    wu: "Empty",
    rq: "Date"
  },
  login: {
    welcome: "Welcome to iot management system",
    title: "User Login",
    loginBtn: "Login",
    usernameRule: "Username is required",
    passwordRule: "Password is required",
    codeRule: "Please enter the verification code",
    username: "username",
    password: "password",
    code: "Verification code",
    codeError: "If the verification code fails to be obtained, click Obtain againr"
  },
  home: {
    title: "Smart Chiller Plant Management Platform",
    admin: "Admin "
  },
  head: {
    jsc: "Dashboard",
    yxjk: "Op.Mon.",
    sjfx: "DataAnal",
    yxbb: "Op.Reports",
    ywgl: "Op.Mgmt.",
    htgl: "Ad.Mgmt.",
    qp: "Fullscreen",
    fh: "Back"
  },
  home_page: {
    nhsj: "EC Data",
    nxsj: "E.E. Data",
    sbcs: "E. Cons. Metrics",
    jnl: "E. Saved",
    nhzb: "E. Cons. %",
    ssnx: "Real-Time E.E.",
    rhdl: "D. E. Cons.",
    rnx: "D. E.E.",
    rgll: "D. C. Dem.",
    ldswd: "C. W. TEMP"
  },
  eedata: {
    dCop: "DayCOP",
    mCop: "MonthCOP",
    yCop: "YearCOP",
    target: "Target"
  },
  esdata: {
    jnlD: "DayDESR",
    jnlM: "MonthDESR",
    jnlY: "YearDESR",
    jnl: "Energy Saved"
  },
  dataQuery: {
    sjfx: "Data Anal",
    nhhz: "Sum of EC",
    lssj: "HIST-DATA",
    nhcx: "ECQ",
    sbnhzb: "EEC%",
    csxz: "Parameter Selection",
    nxrl: "EECalendar",
    jxgs: "Critical",
    yb: "Average",
    lh: "Good",
    yx: "Excellent",
    wdxz: "Latitude Selector",
    sjxz: "Time Selector",
    dw: "Unit:kWh",
    dc: "Export",
    wdcx: "Queries",
    fam: "Scheme ",
    quanxuan: "Check All",
    fx: "Inverse",
    drsbnhzb: "E. Cons. %",
    rbx: "DC",
    zll: "CC",
    rhdl: "DEC",
    gldj: "UCC",
    gjcs: "KP",
    ldbscxs: "CHWPA",
    lqbscxz: "CWPA",
    lqtxtnx: "CTA",
    nh: "EC",
    zb: "EC%"
  },
  report: {
    rbb: "Daily Report",
    ybb: "Monthly Report",
    nbb: "Yearly Report",
    sbyxrz: "Run Log",
    yxzd: "Run Diagnostics",
    bj: "Alarm",
    jnl: "Energy Saved",
    hdl: "Electricity Consumption",
    glfb: "Cooling Distribution",
    zjll: "Equipped Capacitor",
    drsbnhzb: "ENC%",
    nhgl: "Energy consumption overview",
    nhzb: "Energy consumption ratio",
    sjtj: "Data statistics",
    nxgl: "Energy Efficiency Overview",
    glsc: "Cooling duration",
    dgsd: "Trough",
    gfsd: "Rush Hour",
    psd: "Quiet Period",
    gll: "Cool. Dem.",
    fhl: "Load Rate",
    zj: "Host",
    lqsb: "Cooling Water Pump",
    ldsb: "Chilled Water Pump",
    lqt: "Cooling Tower",
    lj: "Cold Price",
    nx: "Energy Efficiency",
    rdf: "Daily Tariff",
    ydf: "Monthly Tariff",
    lqb: "Cooling Pump",
    yglsc: "M.C.D",
    rjglsc: "A.D.C.D",
    yglts: "M.C.Days"
  },
  rb: {
    title: "Cooling Report",
    date: "Date",
    temperature: "Temperature: ",
    humidity: "Relative Humidity: ",
    wet_bulb_temperature: "Wet Bulb Temperature: ",
    energy_efficiency: "Average Energy Efficiency: ",
    cooling_price: "Cooling Price: ",
    cooling_quantity: "Cooling Quantity: ",
    power_consumption: "Power Consumption: ",
    estimated_cost: "Estimated Cost: ",
    start_time: "Start Time: ",
    end_time: "End Time: ",
    cooling_duration: "Total Cooling Duration: ",
    average_supply_temperature: "Average Supply Temperature: ",
    temperature_difference: "Average Supply Temperature Difference: ",
    average_return_temperature: "Average Return Temperature: ",
    approach_degree: "Average Approach Degree: ",
    year_to_date_efficiency: "Year-to-date Overall Energy Efficiency: ",
    year_to_date_cooling_price: "Year-to-date Cooling Price: ",
    encouragement: "Keep it up!"
  },
  nb: {
    title: "Cooling Monthly Report",
    energy_efficiency: "Average Energy Efficiency of your machine room this month: ",
    cooling_price: "Average Cooling Price of your machine room this month: ",
    cooling_quantity: "Total Cooling Quantity: ",
    power_consumption: "Power Consumption: ",
    estimated_cost: "Estimated Cost: ",
    total_cooling_duration: "Total Cooling Duration this month: ",
    daily_cooling_duration: "Average Daily Cooling Duration: ",
    wet_bulb_temperature: "Average Wet Bulb Temperature: ",
    as_of_yesterday: "As of yesterday",
    as_of_end_of_month: "As of the end of the month",
    year_to_date_efficiency: "Year-to-date Overall Energy Efficiency: ",
    year_to_date_cooling_price: "Cooling Price: ",
    encouragement: "Keep it up!",
    compare_last_month: "CWLM"
  },
  nbyl: {
    date: "Date",
    host_power_consumption: "HPC(kWh)",
    freezer_pump_power_consumption: "FPPC(kWh)",
    cooling_pump_power_consumption: "CPPC(kWh)",
    cooling_tower_power_consumption: "CTPC(kWh)",
    total_power_consumption: "TPC(kWh)",
    total_cooling_capacity: "TCC(kWh)",
    electricity_fee: "EF(RM)",
    comprehensive_efficiency: "CE"
  },
  yb: {
    annual_report_title: "Cooling Annual Report",
    average_efficiency: "The average energy efficiency of your machine room for the year is:",
    cooling_price: "The average cooling price of your machine room for the year is:",
    cooling_capacity: "Total cooling capacity is:",
    power_consumption: "Power consumption is:",
    estimated_cost: "Estimated electricity cost:",
    total_supply_duration: "Total cooling duration for the year is:",
    daily_supply_duration: "Average daily cooling duration is:",
    cooling_days: "Total cooling days in the year are:",
    xzndbg: "download report"
  },
  runType: {
    yxrz: "Running Log",
    bh: "Num",
    sj: "Time",
    lx: "Type",
    mc: "Name",
    shijian: "Event",
    sbsszt: "Realtime Mode",
    zj: "Mainframe",
    ldxt: "Refrigeration system",
    lqxt: "Cooling system",
    lqtxt: "Cooling tower system",
    bjhf: "Alarm recovery",
    fsbj: "Alarm",
    sbqt: "device state",
    qd: "Start",
    tz: "Stop"
  },
  diagnosis: {
    start_time: "Start Time",
    select_start_time: "Select Start Time",
    end_time: "End Time",
    select_end_time: "Select End Time",
    diagnose: "Diagnose",
    view_diagnosis_history: "View Diagnosis History",
    download: "Download",
    basic_info: "Basic Information",
    time_interval: "Time Interval",
    to: "to",
    startup_duration: "Startup Duration",
    hours: "hours",
    average_efficiency: "Average Efficiency",
    power_consumption: "Power Consumption",
    cooling_capacity: "Cooling Capacity",
    supply_water_temperature: "Supply Water Temperature",
    diagnosis_abnormal_info: "Diagnosis Abnormal Information",
    room_is_running_smoothly: "The room is running smoothly",
    operation_suggestions: "Operation Suggestions",
    no_suggestions: "No Suggestions",
    comprehensive_score: "Comprehensive Score",
    diagnosis_analysis: "Diagnosis Analysis",
    cancel: "Cancel",
    lqsxtnx: "C.W.S.E.E.",
    jfnx: "M.R.E.E.",
    lqtxtnx: "C.T.S.E.E.",
    ldsxtnx: "C.W.P.E.E.",
    zjnx: "M.E.E.E"
  },
  alarm: {
    alarm_statistics: "Alarm Statistics",
    today: "Today",
    this_month: "Month",
    this_year: "Year",
    alarm_quantity: "Alarm Quantity",
    daily: "D",
    monthly: "M",
    yearly: "Y",
    alarm_level: "Alarm Level",
    alarm_clearance: "Alarm Clearance",
    start_date: "Start Date",
    select_date: "Select Date",
    end_date: "End Date",
    alarm_type: "Alarm Type",
    select_alarm_type: "Please Select",
    alarm_status: "Alarm Status",
    select_alarm_status: "Please Select",
    search: "Search",
    reset: "Reset",
    alarm_content: "Alarm Content",
    alarm_value: "Alarm Value",
    confirmed: "Confirmed",
    not_confirmed: "Not Confirmed",
    operation: "Operation",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  energy: {
    energy_statistics: "Energy Saving Statistics",
    today: "Today",
    this_month: "Month",
    this_year: "Year",
    energy_trends: "Energy Saving Trends",
    co2_reduction: "CO2 Reduction",
    total_co2_reduction: "Total CO2 Reduction",
    energy_data: "Energy Saving Data",
    start_date: "Start Date",
    end_date: "End Date",
    select_month: "Select Month:",
    to: "To",
    search: "Search",
    start_month: "Start Month",
    end_month: "End Month",
    daily: "D",
    monthly: "M",
    yearly: "Y"
  },
  operation: {
    sbgl: "Device Management",
    xjgd: "Work Order",
    gdgl: "Workorder Management"
  },
  sbgl: {
    device_name: "Device Name",
    device_desc: "Device Description",
    field_name: "Associated Point",
    start_count: "Startup Count",
    run_time: "Running Time (Hours)",
    maintenance_time: "Last Maintenance Time",
    maintenance_cycle: "Maintenance Cycle (Days)",
    maintenance_next: "Days Until Next Maintenance",
    operation: "Operation",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    reset: "Reset",
    add_device: "Add Device",
    batch_import: "Batch Import",
    download_template: "Download Import Template",
    batch_delete: "Batch Delete",
    select_date: "Select Date",
    today: "Today",
    confirm: "Confirm",
    cancel: "Cancel"
  },
  gdgl: (_gdgl = {
    entryName: "Project Name",
    workOrderType: "Work Order Type",
    workOrderStatus: "Work Order Status",
    filterTime: "Submission Time",
    startDate: "Start Date",
    endDate: "End Date",
    submit: "Submitted by Me",
    review: "Reviewed by Me",
    send: "Sent to Me",
    edit: "Edit",
    view: "View",
    handler: "Select Handler",
    ccUser: "Select CC User",
    detail: "Processing Content",
    uploadImage: "Upload Image (Max 2MB per image)",
    assign: "Confirm Transfer",
    close: "No Action Needed, Close Directly",
    complete: "Processing Completed",
    reassign: "Cannot Process, Assign to Another",
    assignNext: "Assign to the Next Person",
    closeOrder: "Processing Completed, Close Work Order"
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "entryName", "Project Name"), "workOrderTypeName", "Work Order Type"), "submitterName", "Submitter"), "workOrderStatusName", "Work Order Status"), "handlerTypeName", "Processing Status"), "createTime", "Work Order Submission Time"), "workOrderDate", "Last Update Time"), "index", "Number"), "action", "Handle"), "workOrderStatus_0", "Not processed"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "workOrderStatus_1", "In progress"), "workOrderStatus_2", "Closed"), "handlerType_1", "Pending my processing"), "handlerType_2", "Processing by me"), "handlerType_3", "Processed"), "workOrderType", "Work Order Type"), "workOrderStatus", "Work Order Status"), "all", "All"), "deviceFailure", "Device Failure"), "other", "Other"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_gdgl, "pending", "Pending"), "processing", "Processing"), "closed", "Closed"), "reset", "Reset")),
  xjgd: {
    title: "Work Order Management",
    selectProject: "Select Project",
    orderType: "Work Order Type",
    selectHandler: "Select Handler",
    selectCcUser: "Select CC User",
    eventDescription: "Event Description",
    sitePhotos: "Site Photos",
    submitOrder: "Submit Work Order",
    projectPlaceholder: "Please select a project",
    orderTypePlaceholder: "Please select a type",
    handlerPlaceholder: "Please select a handler",
    ccUserPlaceholder: "Please select CC user",
    descPlaceholder: "Please enter a description",
    uploadImagePlaceholder: "Upload Image",
    sbgz: "Equipment Fault",
    qt: "Other"
  }
};